import styled from "styled-components";

const ErrorStyled = styled.div`
  p {
    font-size: 1.2rem;
    color: ${props => props.theme.red};
    line-height: 2rem;
    margin-top: 0.5rem;
  }
`;

export default ErrorStyled;
